import { IconProps } from './IconProps';

export const CloseCircle = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect width="32" height="32" rx="16" fill="black" fillOpacity="0.1" />
      <path
        d="M11.2265 19.6205C10.9265 19.9204 10.9204 20.453 11.2326 20.7651C11.5509 21.0773 12.0834 21.0712 12.3772 20.7774L16.0007 17.1538L19.6182 20.7713C19.9243 21.0773 20.4507 21.0773 20.7628 20.7651C21.0749 20.4468 21.0749 19.9266 20.769 19.6205L17.1515 16.003L20.769 12.3795C21.0749 12.0734 21.0811 11.547 20.7628 11.2349C20.4507 10.9228 19.9243 10.9228 19.6182 11.2288L16.0007 14.8462L12.3772 11.2288C12.0834 10.9288 11.5447 10.9166 11.2326 11.2349C10.9204 11.547 10.9265 12.0857 11.2265 12.3795L14.8439 16.003L11.2265 19.6205Z"
        fill="black"
        fillOpacity="0.5"
      />
    </svg>
  );
};
